<template>
	<div>
		<v-expansion-panels accordion popout>
			<v-expansion-panel
				v-for="(carrera, i) in grupo"
				:key="i"
				:disabled="carrera.length == 0"
			>
				<v-expansion-panel-header
					>{{ i }}
					<template v-slot:actions>
						<v-icon color="primary">mdi-menu-down</v-icon>
					</template>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div v-show="carrera.length == 0"><p>¡Nada que mostrar!</p></div>

					<v-card v-for="(materia, m) in carrera" :key="m" tile>
						<v-card-title
							>{{ materia.titulo }}
							<v-icon color="primary">{{
								getIconByRecurso(materia.recurso)
							}}</v-icon></v-card-title
						>
						<v-card-subtitle>{{ materia.recurso }}</v-card-subtitle>
						<v-card-text v-if="materia.hasOwnProperty('disponibilidad')">
							<b>Disponibilidad: </b> {{ materia.disponibilidad }}
						</v-card-text>
						<v-card-actions v-if="materia.hasOwnProperty('link')">
							<v-btn
								text
								color="primary"
								:href="materia.link"
								@click="eventClick(materia.titulo)"
								>Consultar</v-btn
							>
						</v-card-actions>
					</v-card>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>

<script>
export default {
	props: ["grupo"],
	data: () => ({}),
	methods: {
		getIconByRecurso(recurso) {
			switch (recurso) {
				case "Carpeta":
					return "mdi-folder";
				case "Web":
					return "mdi-web";
				case "Archivo":
					return "mdi-file-document-outline";
				case "Guía":
					return "mdi-file-multiple-outline";
				case "Libro":
					return "mdi-book-open-variant";
			}
		},
		eventClick(title) {
			console.warn("CLICK EN ", title);
			this.$ua.trackEvent(`CplusInteraccion`, "OpenMaterial", title);
		}
	}
};
</script>

<style></style>
